(function () {
    'use strict';

    // @ngInject
    Services.TrackJS = function TrackJS($window) {
        return $window.TrackJS || false; // we have to return non undefined otherwise angular errors with "must return a value from $get factory method"
    };

}());
